import { FlexBox, Span, type StyleTextColor, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { useLineItemData } from '../contexts/LineItemDataContext';
import { useCustomerFeedbackGroup } from '../contexts/CustomerFeedbackGroupsContext';
import {
  FeedbackGroupState,
  FeedbackType,
} from '../../constants/customerFeedback';
import type { ItemStatusDisplay } from '../../types/OrderHistory.types';
import { ItemStatusTooltip } from './ItemStatusTooltip';

export type LineItemStatusProps = {
  statuses: Array<ItemStatusDisplay>;
};

export const LineItemStatus = (props: LineItemStatusProps) => {
  const { statuses } = props;
  const [orderStatuses = {}] = useTranslations(['orderStatuses']);
  const { id: lineItemId } = useLineItemData();

  const { customerFeedbackGroupExists: designFeedbackRequestExists } =
    useCustomerFeedbackGroup({
      lineItemId: lineItemId || '',
      requestType: FeedbackType.DOCUMENT_REVIEW,
      groupState: FeedbackGroupState.AWAITING_FEEDBACK,
    });

  // If design feedback group in pending exists for the lineItem we override the status to be `pendingCustomerFeedback` and ignore the `disableItemStatus` parameter
  if (designFeedbackRequestExists) {
    return (
      <Span fontWeight="bold" mr={3} textColor="error">
        {orderStatuses.pendingCustomerFeedback}
      </Span>
    );
  }

  return (
    <>
      {statuses.map(
        ({ statusTranslationKey, color, quantity = null, detail }, index) => {
          return (
            <FlexBox key={index} data-testid="line-item-status">
              <Typography fontWeight="bold" textColor={color as StyleTextColor}>
                {orderStatuses[statusTranslationKey]}
              </Typography>
              {quantity && (
                <Typography
                  fontWeight="bold"
                  textColor={color as StyleTextColor}
                >
                  `x(${quantity})`
                </Typography>
              )}
              {detail ? <ItemStatusTooltip detail={detail} /> : null}
              <Span>{statuses.length - 1 === index ? '' : ', '}</Span>
            </FlexBox>
          );
        }
      )}
    </>
  );
};
